<template>
  <div ref="tableView" class="card table-view" :class="{'outer-border': showOuterBorder}" :style="{ height, maxWidth }">
    <div v-if="title || checkActions.length || $slots.default || filters.length || Object.keys(filter || {}).length || $slots.customFilter" class="table-view-header card-header p-0 d-flex">
      <div class="card-title flex-grow-1">
        <div v-if="checked.length && checkActions.length" class="d-flex align-items-center"
          data-kt-customer-table-toolbar="selected">
          <button @click="$emit('action', { item: checked, action: '일괄 ' + action.text, key: action.key })" v-for="(action, i) in checkActions"
            :key="i" v-if="action && action.text"
            :class="'btn-' + action.variant"
            class="btn me-2" v-text="action.text" />
          <div class="fw-bold">
            <span class="me-2" v-text="checked.length" />Selected
          </div>
        </div>
        <div v-else class="d-flex align-items-center">
          <b v-text="title"></b>

          <template v-for="(val, key, i) in filter">
            <b-form-select v-if="Array.isArray(val)" :key="i" class="me-2 w-auto min-w-100px mw-500px" size="lg"
              v-model="filterValue[key]" @change="page = 1; setFilter()"
              :options="[{ text: $t((columns.find(c => c.key == key) || {}).label || key), value: '' }, ...val]" />
            <div v-else :key="i" class="d-flex align-items-center position-relative">
              <b-icon icon="search" />
              <input maxlength="100" type="text" v-model="filterValue[key]" class="form-control form-control-solid w-150px ps-11" :placeholder="val || 'Search'">
            </div>
          </template>
          <b-form-select v-for="({ label, key, cd }, i) in filters" :key="i" class="me-2 w-auto min-w-100px mw-500px" size="lg"
            v-model="listParams[key]"
            :options="[{ text: $t(label), value: null }, ...$code(cd).filter(c => !filterHides.includes(c.value))]" />

          <!-- 사용자 정의 필터 -->
          <slot name="customFilter"></slot>
        </div>
      </div>
      <div class="card-toolbar flex-grow-0">
        <div class="d-flex justify-content-end w-100">
          <slot></slot>
        </div>
      </div>
    </div>
    <div class="table-view-body card-body p-0" style="height: inherit;">
      <slot name="keyword"></slot>
      <div class="dataTables_wrapper dt-bootstrap4 no-footer" style="height: inherit;">
        <div class="table-responsive d-flex flex-column" :style="{ minHeight }">
          <table :style="{ minWidth }" class="table align-middle table-row-bordered gy-3 fs-6 dataTable no-footer">
            <slot v-if="$slots.thead" name="thead" />
            <thead v-else-if="device == 'WEB'">
              <tr class="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                <th v-if="checkActions.length && device == 'WEB'" class="w-10px pe-2 sorting_disabled">
                  <div class="form-check form-check-sm form-check-custom form-check-solid me-3">
                    <input @change="onCheck($event.target)" class="form-check-input" type="checkbox">
                  </div>
                </th>
                <th class="sorting" v-for="({ key, label, width }, i) in cols" :width="width" :key="i"
                  v-text="$t(label || key)" />
                <th v-if="iconActions || actions.length" class="sorting_disabled w-auto">
                  <span v-if="device == 'WEB'" :class="{'d-none': hideActionLabel}">Actions</span>
                </th>
              </tr>
            </thead>
            <tbody class="fw-semibold text-gray-700 menu-sub-right">
              <tr v-for="(item, i) in pageList" :key="i" :class="[i % 2 ? 'odd' : 'even', {'cursor-pointer':actionFlag}]"
                @click="$emit('action', { event: $event, item, action: 'view' })">
                <td @click.stop v-if="checkActions.length && device == 'WEB'">
                  <div class="form-check form-check-sm form-check-custom form-check-solid">
                    <input :checked="checked.includes(item)" @change="onCheck($event.target, item)"
                      class="form-check-input" type="checkbox">
                  </div>
                </td>
                <template v-for="({ key, renderer, style, type, component, element, defaultValue }, colIdx) in cols">
                  <td v-if="component" :style="style">
                    <component :is="component(item)"></component>
                  </td>
                  <td v-else-if="element" :style="style">
                    <template v-if="element.type == 'date'">
                      <input type="date" min="2023-01-01" max="9999-12-31" class="form-control" style="max-width: 150px; margin: 0 auto;" :value="item[key] || element.default"
                        onfocus="this.showPicker()" @change.stop="$emit('action', { event: $event, item, action: key })">
                    </template>
                    <template v-if="element.type == 'check'">
                      <div class="form-check form-switch form-check-custom form-check-solid" style="max-width: 30px; margin: 0 auto;">
                        <div class="custom-control custom-switch">
                          <input type="checkbox" class="custom-control-input" :id="`check_${colIdx}_${i}`" :checked="item[key] || element.default" 
                            @change.stop="$emit('action', { event: $event, item, action: key })">
                          <label class="custom-control-label" :for="`check_${colIdx}_${i}`"></label>
                        </div>
                      </div>
                    </template>
                  </td>
                  <td v-else :style="style" v-html="renderer ? renderer(item, scope) : item[key] && item[key].f ? item[key].f(type) : defaultValue">
                  </td>
                </template>
                <td v-if="iconActions" style="white-space:nowrap; text-align: center;" class="justify-center sel-act-td">
                  <a v-if="actionFilter(item, action)" v-for="(action, icon, i) in iconActions" :key="i" @click.stop="$emit('action', { item, action })"
                    class="icon btn btn-sm btn-icon btn-circle btn-icon-primary btn-active-light-primary mx-1" :title="$t(action)">
                    <i v-if="icon" class="'bi fs-4" :class="icon"></i>
                  </a>
                </td>
                <td v-else-if="getActions(item).length" class="text-end menu-item pe-1">
                  <template v-if="device == 'WEB'">
                    <a v-if="getActions(item).length == 1" :class="`btn btn-light-primary btn-${actionSize}`" @click.stop="$emit('action', { item, action: getActions(item)[0] })">
                      {{$t(getActions(item)[0])}}
                    </a>
                    <b-dropdown v-else variant="light-primary" size="sm" class="table-action">
                      <template #button-content>Actions</template>
                      <b-dropdown-item v-if="actionFilter(item, action)" v-for="(action, i) in actions" :key="i" @click.stop="$emit('action', { item, action })">
                        {{action}}
                      </b-dropdown-item>
                    </b-dropdown>
                  </template>
                  <template v-else>
                    <b-dropdown size="sm" variant="link" class="table-action" toggle-class="text-decoration-none" no-caret>
                      <template #button-content>
                        <a class="btn btn-circle btn-secondary btn-icon" :title="$t('기능')">
                          <i class="bi bi-three-dots-vertical fs-6"></i>
                        </a>
                      </template>
                      <b-dropdown-item v-if="actionFilter(item, action)" v-for="(action, i) in actions" :key="i" @click.stop="$emit('action', { item, action })">
                        {{action}}
                      </b-dropdown-item>
                    </b-dropdown>
                  </template>
                </td>
                <td v-else-if="actions && actions.length > 0"></td>
              </tr>
            </tbody>
          </table>
          <div v-if="list.length == 0" class="d-flex flex-center p-4" style="margin: auto 0;" v-text="emptyMsg" />
        </div>
      </div>
    </div>
    <div class="table-view-footer" v-if="!hidePagination">
      <div class="p-5 justify-between">
        <div v-if="device == 'WEB'">
          <div class="dataTables_length"><b-form-select v-model="pageSize" :options="[5, 10, 25, 50, 100]" /></div>
        </div>
        <div class="flex-grow-1 d-flex align-items-center justify-content-center">
          <div class="dataTables_paginate paging_simple_numbers">
            <ul class="pagination">
              <li :class="{ disabled: page < 2 }" class="paginate_button page-item previous"><a
                  @click="page = Math.max(1, page - 1)" class="page-link"><i class="previous" /></a></li>
              <li v-for="i in 5" :key="i" v-if="startPage + i <= totalPage" :class="{ active: startPage + i == page }"
                class="paginate_button page-item"><a @click="page = startPage + i" class="page-link"
                  v-text="startPage + i" /></li>
              <li :class="{ disabled: page >= totalPage }" class="paginate_button page-item next"><a
                  @click="page = Math.min(totalPage, page + 1)" class="page-link"><i class="next" /></a></li>
            </ul>
          </div>
        </div>
        <div v-if="device == 'WEB'">
          <div v-if="serverTotal" class="me-5" v-text="`total: ${serverTotal || list.length}`"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {},// 필터가 없는경우 표시되는 테이블의 타이틀
    minWidth: { default: () => {} },// 최소 넓이
    maxWidth: { default: () => {} },// 최소 넓이
    minHeight: { default: () => {} },// 최소 높이
    height: { default: () => 'none' },
    columns: {},// 컬럼정보 [{key,label,width,renderer,style:{textAlign,...},...}]
    list: { default: () => [] },// 전체 목록
    keepPage: Boolean,// 데이터를 갱신할때 페이지가 유지
    filter: { default: () => [] },// 목록 표시될 필터 {key:[option...]}
    filterHides: { default: () => ['DEL'] },// 필터중 숨김처리할 코드값
    actionFlag: { default: () => true },
    filters: { default: () => [] },// 목록 표시될 필터 [{label,key,cd}]
    checkActions: { default: () => [] },// 체크박스 선택후 일괄 처리될 액션 (비어있으면 선택UI 숨김)
    actions: { default: () => [] },// row 별로 처리될 액션
    iconActions: {},
    actionFilter: { default: () => () => true },// 특정 로직으로 엑션 숨김
    actionSize: { default: () => 'sm' },
    // todo: 다음목록이 필요할때 $emit('nextList') 필터가 있는경우 페이지처리가 애매함
    serverTotal: { default: 0 },// 서버의 전체 목록수를 받아와 페이지 처리
    hidePagination: Boolean, defaultEmptyMsg: { default: () => '목록을 검색중 입니다.' },
    showOuterBorder: Boolean,
    hideActionLabel: Boolean,
  },
  computed: {
    scope() { return this },
    // 현재페이지에 표시할 목록
    pageList() { return this.filteredList.slice((this.page - 1) * this.pageSize, this.page * this.pageSize) },
    // 전체 페이지
    totalPage() { return Math.ceil((this.serverTotal || this.filteredList.length) / this.pageSize) },
    // pagenation 에 표시될 시작페이지
    startPage() { return Math.floor((this.page - 1) / 5) * 5 },
    // 컬럼정보 (columns를 복제하거나 데이터에서 추출)
    cols() { return Array.isArray(this.columns) ? this.columns.filter(c => !c.hide || !c.hide.includes('td')) : this.list.length ? Object.keys(this.list[0]).map(key => ({ key })) : [] },
    listParams() { return this.$parent.$parent.listParams || {} },
    device() { return this.$getDevice(); },
  },
  data: () => ({
    filteredList: [],// list 에서 filter 된 목록
    filterValue: {},// filter 선택된 값
    checked: [],// 체크박스 선택된 목록
    page: 1,// 현재 페이지
    fromNextList: false,
    pageSize: 10,// 페이지당 표시될 목록 수
    emptyMsg: '',
  }),
  created() {
    if (this.hidePagination) this.pageSize = 9999;
    if (this.list.length) this.setFilter(this.list);
    this.emptyMsg = this.$t(this.defaultEmptyMsg);    
  },
  mounted() {
    if (['IPAD', 'MOBILE'].includes(this.device)) {
      this.pageSize = 10;
    }
  },
  watch: {
    filterHides: "checkFilters",
    pageSize: "setPageSize",// pageSize 변경시
    list: "setFilter",// 원본목록 변경시 (추가 데이터를 가져오는 경우 등)
    page(now, old) {
      if (old < now) {
        this.nextList();
      }

      if(['IPAD', 'MOBILE'].includes(this.device)) {
        setTimeout(() => { document.querySelector('.app-content').scrollIntoView(); }, 150);
      }
    },
  },
  methods: {
    checkFilters() {
      for (const { key } of this.filters) if (this.filterHides.includes(this.listParams[key])) this.listParams[key] = null;
    },
    nextList() {
      if (this.filteredList.length >= this.serverTotal || this.pageSize * this.page <= this.filteredList.length) return;
      this.fromNextList = true;
      this.$emit('nextList');
    },
    getActions(item) {
      return this.actions.filter(act => this.actionFilter(item, act) && act != null);
    },
    showActions(evt, item) {
      const menu = {}, cb = action => this.$emit('action', { item, action });
      for (const action of this.getActions(item)) menu[action] = cb;
      this.$store.commit('contextmenu', { evt, menu });
    },
    /** 필터값 변경시 실행 */
    setFilter(list, oldList) {
      try {
        if (list) this.emptyMsg = this.emptyMsg == this.$t(this.defaultEmptyMsg) && (list.length || oldList.length == 0) ? this.emptyMsg = this.$t('목록이 없습니다.') : this.$t(this.defaultEmptyMsg);
      } catch (e) { console.log(e) }
      if (list == this.list) Object.keys(this.filter).forEach(key => this.filterValue[key] = '');
      if (!this.fromNextList && !this.keepPage) this.page = 1;
      else this.fromNextList = false;
      this.checked = [];
      this.filteredList = this.list.filter(item => {
        for (const key in this.filterValue) {
          if (this.filterValue[key] && this.filterValue[key] != item[key]) return false;
        }
        return true;
      });
    },
    /** pageSize 변경시 실행 */
    setPageSize(pageSize, old) {
      this.page = Math.floor((this.page - 1) * old / pageSize) + 1;
    },
    /** 목록이나 상단의 체크박스 클릭시 */
    onCheck(el, item) {
      if (!item)
        if (el.checked) this.checked = [...this.pageList];
        else this.checked = [];
      else if (el.checked && !this.checked.includes(item)) this.checked.push(item);
      else if (!el.checked && this.checked.includes(item)) this.checked.splice(this.checked.indexOf(item), 1);
    },
  }
}
</script>

<style>
.table-view .table {
  min-width: 900px;
}

.table-view .table-responsive {
  min-height: 485px;
}

.app-mobile, .app-ipad {
  background-color: unset;
}

.app-mobile .table-view .table, .app-ipad .table-view .table {
  min-width: auto;
}

.app-mobile .table-responsive, .app-ipad .table-responsive {
  min-height: 80px;
}

.app-mobile .page-item .page-link, .app-ipad .page-item .page-link {
  font-size: 1.5rem !important;
  padding: 1.5rem 1.25rem !important;
}
</style>
